function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgDeliveryTruck = function SvgDeliveryTruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M128,160c0-8.832-7.168-16-16-16H16c-8.832,0-16,7.168-16,16s7.168,16,16,16h96 C120.832,176,128,168.832,128,160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M112,208H48c-8.832,0-16,7.168-16,16s7.168,16,16,16h64c8.832,0,16-7.168,16-16S120.832,208,112,208 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M112,272H80c-8.832,0-16,7.168-16,16s7.168,16,16,16h32c8.832,0,16-7.168,16-16S120.832,272,112,272 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F44336"
    },
    d: "M509.728,263.776l-48-80C458.848,178.944,453.632,176,448,176H336c-8.832,0-16,7.168-16,16v160 c0,8.832,7.168,16,16,16h160c8.832,0,16-7.168,16-16v-80C512,269.088,511.232,266.24,509.728,263.776z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "384,208 438.944,208 477.344,272 384,272 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M336,112H112c-8.832,0-16,7.168-16,16v224c0,8.832,7.168,16,16,16h240V128 C352,119.168,344.832,112,336,112z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAFAFA"
    },
    cx: 432,
    cy: 352,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M432,400c-26.464,0-48-21.536-48-48s21.536-48,48-48s48,21.536,48,48S458.464,400,432,400z M432,336 c-8.8,0-16,7.2-16,16s7.2,16,16,16s16-7.2,16-16S440.8,336,432,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F44336"
    },
    d: "M352,368H112c-8.832,0-16-7.168-16-16v-48h256V368z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAFAFA"
    },
    cx: 208,
    cy: 352,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M208,400c-26.464,0-48-21.536-48-48s21.536-48,48-48s48,21.536,48,48S234.464,400,208,400z M208,336 c-8.832,0-16,7.2-16,16s7.168,16,16,16s16-7.2,16-16S216.832,336,208,336z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeliveryTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivery-truck.d31f6b6a.svg";
export { ForwardRef as ReactComponent };